document.addEventListener("DOMContentLoaded", function(){
  let navigation = document.querySelector(".nav-bar").cloneNode(true);
  document.querySelector('#MobileNav .header-utilities').before(navigation);
   let mobileSearch = document.querySelector('.mobile-nav__search');
  document.querySelectorAll(".mn__back").forEach((el)=>{
    el.addEventListener("click", function(e){
      console.log("click");
      e.target.closest(".active").classList.remove("active");
    })
  })

  const blockSearchMobile = document.querySelector(".block-search--mobile");
  if (blockSearchMobile) {
    blockSearchMobile.addEventListener("click",function(){
      mobileSearch.classList.add('opened');
      mobileSearch.style.display = "";
    });
  }

  const searchClose = document.querySelector(".search_close");
  if (searchClose) {
    searchClose.addEventListener("click",function(){
      mobileSearch.classList.remove('opened');
      setTimeout(function(){
        mobileSearch.style.display = "none";
      }, 450);
    }); 
  }

  const alphabetMenuLinks = [...document.querySelectorAll('.nav-main-content .alphabet li')];
  alphabetMenuLinks.forEach((link) => {
    link.addEventListener('click', function(e) {
      const menuToggle = document.querySelector('.menu-toggle');
      menuToggle && menuToggle.click();
      document.body.classList.remove('show-overlay');
      e.target.closest('.level-1').classList.add('hide-nav');
    });
    link.addEventListener('mouseleave', function(e) {
      e.target.closest('.level-1').classList.remove('hide-nav');
    })
  });

  var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});

  initGorgiasChatPromise.then(async () => {
    console.log('Gorgias chat initialized');
  })

});
